import { useTranslation } from 'react-i18next';

import { isVerdictPassing } from '@/schemas/judges';

import {
	VERDICT_BADGE_BASE,
	VERDICT_BADGE_FAIL,
	VERDICT_BADGE_NEUTRAL,
	VERDICT_BADGE_PASS,
} from './VerdictBadge.constants';
import type { VerdictBadgeProps } from './VerdictBadge.types';

export const VerdictBadge = ({ verdict }: VerdictBadgeProps) => {
	const { t } = useTranslation('translation', { keyPrefix: 'verdict' });

	if (!verdict) {
		return <span className={`${VERDICT_BADGE_BASE} ${VERDICT_BADGE_NEUTRAL}`}>—</span>;
	}

	const passing = isVerdictPassing(verdict);

	if (verdict.kind === 'rubric' && verdict.scale === 'likert_5') {
		const score = Number(verdict.status);

		return (
			<span className={`${VERDICT_BADGE_BASE} ${passing ? VERDICT_BADGE_PASS : VERDICT_BADGE_FAIL}`}>
				{t('SCORE', { score })}
			</span>
		);
	}

	if (verdict.kind === 'checklist') {
		const total = verdict.results.length;
		const passed = verdict.results.filter((r) => r.passed).length;

		return (
			<span className={`${VERDICT_BADGE_BASE} ${passing ? VERDICT_BADGE_PASS : VERDICT_BADGE_FAIL}`}>
				{passed}/{total}
			</span>
		);
	}

	return (
		<span className={`${VERDICT_BADGE_BASE} ${passing ? VERDICT_BADGE_PASS : VERDICT_BADGE_FAIL}`}>
			{passing ? t('PASSED') : t('FAILED')}
		</span>
	);
};
